import React from 'react';

import { AddMerchandisePage, MerchandisePage } from '../../../pages';
import {
  isAdmin,
  isImpExpAdmin,
  isSuperAdmin,
  isTransporter,
} from '../../roles';
import { Routes } from '../../types/route';

export const merchandiseRoutes = (useRole: string): Routes[] => {
  return [
    // Super-Admin
    {
      path: '/super-admin/mercaderias',
      component: <MerchandisePage />,
      isAvailable: isSuperAdmin(useRole),
    },
    {
      path: '/super-admin/mercaderias/nuevo',
      component: <AddMerchandisePage />,
      isAvailable: isSuperAdmin(useRole),
    },
    {
      path: '/super-admin/mercaderias/:merchandise_id/editar',
      component: <AddMerchandisePage />,
      isAvailable: isSuperAdmin(useRole),
    },
    // Admin
    {
      path: '/admin/mercaderias',
      component: <MerchandisePage />,
      isAvailable: isAdmin(useRole),
    },
    {
      path: '/admin/mercaderias/nuevo',
      component: <AddMerchandisePage />,
      isAvailable: isAdmin(useRole),
    },
    {
      path: '/admin/mercaderias/:merchandise_id/editar',
      component: <AddMerchandisePage />,
      isAvailable: isAdmin(useRole),
    },
    // Transporter
    {
      path: '/transportista/mercaderias/nuevo',
      component: <AddMerchandisePage />,
      isAvailable: isTransporter(useRole),
    },
    {
      path: '/transportista/mercaderias/:merchandise_id/editar',
      component: <AddMerchandisePage />,
      isAvailable: isTransporter(useRole),
    },
    {
      path: '/transportista/mercaderias',
      component: <MerchandisePage />,
      isAvailable: isTransporter(useRole),
    },
    // Clients
    {
      path: '/cliente/mercaderias',
      component: <MerchandisePage />,
      isAvailable: isImpExpAdmin(useRole),
    },
    {
      path: '/cliente/mercaderias/nuevo',
      component: <AddMerchandisePage />,
      isAvailable: isImpExpAdmin(useRole),
    },
    {
      path: '/cliente/mercaderias/:merchandise_id/editar',
      component: <AddMerchandisePage />,
      isAvailable: isImpExpAdmin(useRole),
    },
  ];
};
